var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSingle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10418:23658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10418:23658)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FFEADB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-10.8027 71.5636L-2.57444 70.7784C-1.91471 70.7153 -1.29069 71.09 -1.03603 71.7021L5.17614 86.6481C5.56598 87.5863 4.93648 88.6334 3.92476 88.7302L-4.63691 89.5476C-5.3083 89.6113 -5.94065 89.2234 -6.18674 88.5963L-12.0655 73.6179C-12.4318 72.6843 -11.802 71.6595 -10.8027 71.5636Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.58762 98.2482C-2.73232 98.3729 -9.64919 91.3055 -13.3427 87.3897L-9.643 85.1387L10.5576 97.8141L-2.58762 98.2482Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5113 14.9803C53.6422 14.3623 55.2892 7.74657 65.5611 9.17243C65.5611 9.17243 60.437 8.89744 59.1852 10.9525C59.1852 10.9525 63.0788 8.82132 65.7086 10.1825C68.3409 11.5434 69.1262 16.703 68.8644 18.3094C68.6003 19.9156 66.1537 24.8157 64.3116 24.9477C63.6119 24.9979 62.8503 24.8192 62.1696 24.5783C62.5123 25.3935 62.8336 26.2831 63.1168 27.2637C65.7348 36.331 60.111 43.7692 56.8195 42.2668C54.7085 41.3031 53.4257 44.9672 53.4257 44.9672L34.9626 23.8394C34.9626 23.8394 45.6979 8.88769 53.5113 14.9803Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6174 71.6369C37.0264 73.307 40.0465 74.6844 43.8378 75.5588C58.0485 78.8406 63.4939 66.8355 65.5406 58.5949C63.601 57.4864 61.7779 57.2421 60.726 57.1165C59.6979 56.9954 58.6174 56.915 57.7225 56.8707C56.1279 55.649 53.7503 50.649 53.2244 42.8862L52.5556 43.0654L41.3555 46.1292C41.3555 46.1292 41.8672 49.6877 42.1195 53.0513C42.3146 55.683 42.3456 58.1983 41.8458 58.8137C40.9723 59.0031 40.4464 59.127 40.4464 59.127C40.4464 59.127 40.4464 59.1308 40.4416 59.1375C40.2917 59.3839 37.0406 64.7248 34.6174 71.6369Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3557 46.1308C41.3557 46.1308 41.8697 49.6864 42.1196 53.0529C48.4646 52.4177 51.4086 46.3796 52.5557 43.0674L41.3557 46.1308Z",
    fill: "#BF9976"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4602 49.472C39.4602 49.472 54.5205 48.6416 53.8589 39.2748C53.1973 29.9083 54.6943 23.4927 45.0507 23.6271C35.4061 23.7612 33.7925 27.4672 33.2525 30.6472C32.7127 33.8276 35.5242 49.4471 39.4602 49.472Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3272 25.4087C35.4502 22.4247 37.2525 22.9167 38.2973 23.6931C46.1964 18.5856 51.9726 24.8858 51.9726 24.8858C53.4624 31.5339 58.5865 35.0359 58.5865 35.0359C58.5865 35.0359 55.9661 36.9252 49.5283 35.7539C47.5625 35.3958 45.7394 34.1479 44.1544 32.5896C47.0199 36.6921 50.7231 39.53 50.7231 39.53C42.924 36.5831 39.1374 26.3043 38.7566 25.2158C37.8975 26.1061 36.2148 28.0266 35.7895 29.8211C35.211 32.2599 35.2257 37.194 33.7823 37.1293C33.7823 37.1293 30.1431 29.8834 33.3272 25.4087Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0213 58.3736C37.0213 58.3736 61.5587 52.4197 72.2257 61.2144L63.8211 98.3738L66.8945 135.535L18.9095 123.949C18.9095 123.949 20.2597 119.246 29.4611 106.74C38.6635 94.2347 34.6601 75.8916 37.0213 58.3736Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5326 82.4127C74.3498 91.3537 69.6113 102.295 67.9191 108.184C67.9191 108.184 70.7465 128.631 68.0452 134.245C67.7406 134.885 67.3598 135.333 66.8933 135.535C56.888 139.891 17.9228 135.661 16.278 123.097C15.6802 118.533 31.1199 102.475 32.0195 100.527C32.3934 99.7211 32.7907 97.1087 30.9809 91.6946C28.4149 99.6015 23.6761 108.732 18.9091 110.289C13.6708 112.002 -7.0425 96.5744 -7.0425 96.5744C-7.0425 96.5744 -7.16197 94.7004 -4.54354 92.928C-2.85972 91.788 1.00771 91.4039 1.00771 91.4039L14.2529 97.328C15.9151 94.4854 20.0564 74.8184 24.68 65.9407C28.1564 59.267 37.4389 58.3002 37.4389 58.3002C37.4389 58.3002 41.3016 64.4247 50.6454 63.556C59.9867 62.6875 61.6955 56.9712 61.6955 56.9712C61.6955 56.9712 69.9825 58.0721 72.5338 60.131C72.9765 60.488 77.0867 70.6988 75.5326 82.4127Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9198 108.184C67.9198 108.184 70.7472 128.631 68.046 134.245C60.7562 130.587 51.2554 122.693 54.147 110.358C58.3476 92.4371 75.5333 82.4126 75.5333 82.4126C74.3505 91.3536 69.612 102.295 67.9198 108.184Z",
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6968 56.9712C61.6968 56.9712 73.7325 58.3982 77.0454 63.5559C81.2341 70.0777 90.9696 86.1379 90.6507 92.6832C90.6507 92.6832 90.2442 95.9352 66.6669 116.26C66.6669 116.26 60.2329 114.795 65.4474 111.789C65.4474 111.789 79.7799 91.3779 81.246 90.0867L71.3644 79.5917L61.6968 56.9712Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.5935 71.7257L-4.36499 70.9399C-3.70526 70.8771 -3.081 71.2518 -2.82682 71.8639L3.38559 86.8101C3.77543 87.7478 3.14617 88.7955 2.13445 88.8918L-6.42746 89.7094C-7.09885 89.7734 -7.7312 89.3852 -7.97753 88.7576L-13.8558 73.78C-14.2223 72.8458 -13.5923 71.8208 -12.5935 71.7257Z",
    fill: "#2B478B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSingle);
export default __webpack_public_path__ + "static/media/imgSingle.cd448f8c69fd6db4425bb92f186f5a49.svg";
export { ForwardRef as ReactComponent };